"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _lodash = require("lodash");
var _constants = require("../constants");
const useIsFormValid = reportTitle => {
  const [isFormValid, setIsFormValid] = (0, _react.useState)(true);
  (0, _react.useEffect)(() => {
    const isValid = !(0, _lodash.isEmpty)(reportTitle.trim()) && reportTitle.length <= _constants.NAME_MAX_LENGTH;
    setIsFormValid(isValid);
  }, [reportTitle]);
  return isFormValid;
};
var _default = exports.default = useIsFormValid;